module.exports = __webpack_public_path__ + "vercel.4252dc.svg";